import { AjaxClient } from "app/common/ajax";
import { tt_icon } from "app/common/tooltip";
import * as $ from "jquery";

export class Userlist {
    private readonly ajaxClient: AjaxClient;
    private readonly ajaxLoader: string;
    private readonly ajaxSuccess: string;

    public constructor(ajaxClient: AjaxClient, ajaxLoader: string, ajaxSuccess: string) {
        this.ajaxClient = ajaxClient;
        this.ajaxLoader = ajaxLoader;
        this.ajaxSuccess = ajaxSuccess;

        // Bind the invite link click handlers
        $('.invite-link').click((evt) => {
            const resultSpan = $(evt.currentTarget).parent().find('.invite-result');
            resultSpan.html(this.ajaxLoader);

            const gameId = $(evt.currentTarget).data('game') as string;
            const username = $(evt.currentTarget).data('user') as string;

            void this.ajaxClient.call<IInviteAjaxResult>(`/game/${gameId}/play/send-invite`, { username: username }).then(
                (result: IInviteAjaxResult) => {
                    if (result.success) {
                        resultSpan.html(this.ajaxSuccess);
                    } else {
                        resultSpan.html(tt_icon('times', result.error, false, ['error']));
                    }
                },
                (reason: string) => {
                    resultSpan.html(tt_icon('times', `Cannot invite - ${reason}`, false, ['error']));
                }
            );
            return false;
        });
    }
}

interface IInviteAjaxResult {
    success: boolean;
    error: string;
}
